import { DispatchItem } from "./DispatchItem";
import { ListItem } from "./ListItem";
import { TruckerContact } from "./TruckerContact";

export class DispatchConfirmInfo {
    dispatch: DispatchItem = new DispatchItem();
    truckerName: string = '';
    truckerRogerEnabled: boolean = false;
    dispatchCompuweighEligible: boolean = false;
    truckerContactList: TruckerContact[] = [];
    scoularContactList: ListItem[] = [];
    currentUserId: number = 0;
    groupUserList: ListItem[] = [];
    currentUserName: string = '';
    loadBreakoutOverride: boolean = false;
}